module.exports = __webpack_public_path__ + "static/media/Warande.5340cf53.svg";